import { render, staticRenderFns } from "./BankStatementsModal.vue?vue&type=template&id=6b4dbcd6&scoped=true&"
import script from "./BankStatementsModal.vue?vue&type=script&lang=ts&"
export * from "./BankStatementsModal.vue?vue&type=script&lang=ts&"
import style0 from "./BankStatementsModal.vue?vue&type=style&index=0&id=6b4dbcd6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b4dbcd6",
  null
  
)

export default component.exports